import { Injectable } from '@angular/core';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { IListingSetup } from '@df/catalog-ui/listing/listing';
import { IProductListingConfig, ProductListing } from '@df/catalog-ui/listing/product-listing';

@Injectable({ providedIn: 'root' })
export class ProductListingFactory {
    create<T extends Product = Product<IProductDataV2>>(
        config: Partial<IProductListingConfig>,
        models: T[] | number[],
        setup: IListingSetup<T> = {}
    ): ProductListing<T> {
        return new ProductListing<T>(config, models, setup);
    }
}
